import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Input, Select, Button, Checkbox } from 'loyal-react'
import PropTypes from 'prop-types'

import { actions } from '.'
import { Loading } from '../../Loading'
import ModalServices from '../ModalServices/ModalServices'
import { SecondFactorAuthentication } from 'features/Checkout/SecondFactorAuthenticaton'
import * as checkoutActions from 'features/Checkout/actions'

export const shellSupplierId = 117
const REGULATION_TYPE_VENDOR = 'Vendor'
const first = 'first'
const second = 'second'
const error = 'error'
const success = 'success'
const errorBalance = 'Seu saldo é insuficiente.'
const errorCpf = 'Para realizar a transferência de pontos é necessário ter um CPF cadastrado. Por favor, atualize o seu cadastro.'

class FuelCredit extends Component {
  state = {
    packageSelected: {},
    isValid: null,
    showModal: false,
    acceptTerms: false,
    firstStep: true,
    secondStep: false,
    stepError: false,
    stepFinal: false,
    shellSupplierId
  }

  componentDidMount () {
    if (!this.props.packages || this.props.packages.length < 1) {
      this.props.loadPackagesBySupplierId(
        shellSupplierId,
        this.props.clientId
      )
    }
  }

  componentDidUpdate (prevProps) {
    if (prevProps.order !== this.props.order) {
      this.handleChangeStepFuelCredit(first)
      this.props.navigateToServiceConfirmation(this.props.order.liveOrderId)
    }
  }

  showTerms = () => {
    if (!this.state.packageSelected.id) {
      this.setState({ isValid: false })
    } else {
      this.setState({ showModal: true })
    }
  }

  acceptTermsEvent = checked => {
    this.setState({
      showModal: false,
      acceptTerms: checked
    })
  }

  handlerFinalizePayment = () => {
    if (
      this.props.participantBalance < this.state.packageSelected.pointsQuantity
    ) {
      this.props.redirectFuelCreditError(errorBalance, this.state)
    } else if (
      !this.props.participant.partnerCpf.value
    ) {
      this.props.redirectFuelCreditError(errorCpf, this.state)
    } else {
      this.props.redemptionFuelCredit(this.orderFuelCredit(), this.state)
    }
  }

  handlerChangePackage = packageSelected => {
    this.setState({ packageSelected, isValid: null })
  }

  handleChangeStepFuelCredit = stepValue => {
    this.props.changeStepFuelCredit(stepValue)
  }

  handlerDisableButton = (creditValue, pointsValue, acceptTerms) => {
    const result = !!(creditValue && pointsValue && acceptTerms)
    return !result ? 'disabled' : ''
  }

  handleFormatValue = (value, decimalPlaces) => {
    return value.toLocaleString('pt-br', {
      minimumFractionDigits: decimalPlaces,
      maximumFractionDigits: decimalPlaces
    })
  }

  orderFuelCredit = () => ({
    totalMiles: this.state.packageSelected.milesQuantity,
    totalPoints: this.state.packageSelected.pointsQuantity,
    transferKey: 'cpf',
    loyaltyNumber: this.props.participant.partnerCpf.value,
    cpf: this.props.participant.partnerCpf.value,
    participantName: this.props.participant.name.value,
    offline: false,
    orderItems: [
      {
        quantity: 1,
        points: this.state.packageSelected.pointsQuantity,
        miles: this.state.packageSelected.milesQuantity,
        totalPoints: this.state.packageSelected.pointsQuantity,
        packageName: this.state.packageSelected.title,
        clientProductCode: this.state.packageSelected.clientProductCode,
        pointsAdjustment: this.state.packageSelected.pointsAdjustment,
        partnerCampaignPackageId: this.state.packageSelected
          .partnerCampaignPackageId
      }
    ],
    orderTypeId: 1
  })

  toogleModal () {
    this.props.closeSecondFactorModal()
  }

  btnTryAgain () {
    this.setState({
      firstStep: false,
      secondStep: true,
      stepError: false,
      stepFinal: false
    })
  }

  renderByStep = () => {
    switch (this.props.step) {
      case first:
        return (
          <div className='bx-abasteca  h-100 bg-white radius row px-2 mx-0 pt-3 pb-2'>
            <div className='col-12 my-3 pb-1'>
              <h4 className='txt-uppercase color-brand-6 txt-body-sm mb-1'>
                Crédito de combustível
              </h4>
              <h2 className='color-ui-white txt-title txt-circular-book'>
                Abasteça com {this.props.pointsValue} Shell Box.
              </h2>
            </div>
            <Select
              id='selectFuelCredit'
              label='Créditos em Combustível?'
              className='form-field col-12 mt-3 mt-md-5'
              hasEmpty
              displayValue='description'
              selectedValue='id'
              options={this.props.packages}
              required
              data-error={'Nenhum crédito selecionado'}
              valid={this.state.isValid}
              onChange={this.handlerChangePackage}
              value={
                this.state.packageSelected.id
                  ? this.state.packageSelected
                  : null
              }
            />

            <Button
              id={'btnNextStepFuelCredit'}
              name={'NextStepFuelCredit'}
              className='btn-featured btn btn-sm mt-2 mx-1'
              text='Continuar'
              onClick={() => this.handleChangeStepFuelCredit(second)}
              disabled={!this.state.packageSelected.id}
            />
          </div>
        )

      case second:
        return (
          <div className='bg-white radius row px-1 mx-0 pt-2 pb-3 border-top-lg border-color-featured'>
            <div className='row px-1 mx-0'>
              <div className='col-10'>
                <p className='txt-body-sm my-1'>
                  Abasteça com {'Shell Box'}
                </p>
              </div>
              <div className='col-2 pl-3'>
                <i
                  className='icon icon_close txt-body-sm cursor'
                  onClick={() => this.handleChangeStepFuelCredit(first)}
                />
              </div>
              <Loading ready={!this.props.isLoading}>
                <Select
                  id='selectPointsForTrade'
                  label='Quantos R$ em créditos quer receber?'
                  className='col-12 form-field mt-1'
                  hasEmpty
                  displayValue='description'
                  selectedValue='id'
                  options={this.props.packages}
                  required
                  data-error={'Nenhum crédito selecionado'}
                  valid={this.state.isValid}
                  onChange={this.handlerChangePackage}
                  value={
                    this.state.packageSelected.id
                      ? this.state.packageSelected
                      : null
                  }
                />

                <Input
                  id='totalFuelPoints'
                  className='col-12 form-field mt-2'
                  label='Você vai resgatar'
                  value={`${this.handleFormatValue(
                    this.state.packageSelected.pointsQuantity || 0,
                    this.props.currencyConfiguration.decimalPlaces
                  )} ${this.props.currencyConfiguration.pointsName}`}
                />

                <div className='col-12 row mx-0'>
                  <Checkbox
                    id='aceito_termos_fuel_credit'
                    className='col-auto'
                    labelClass='l-0'
                    checked={this.state.acceptTerms}
                    onChange={e => this.acceptTermsEvent(e.target.checked)}
                  />
                  <div className='col-auto pt-2'>
                    <p className='txt-body-sm'>
                      {' '}
                      Li e aceito os{' '}
                      <a
                        className='txt-body-sm color-brand-2 txt-underline'
                        role='button'
                        onClick={e => this.setState({ showModal: true })}
                      >
                        termos do regulamento
                      </a>
                    </p>
                  </div>
                </div>

                <div className='col-12 pb-1 mb-5'>
                  <Button
                    id={'DoneRecharge'}
                    name={'DoneRecharge'}
                    className='btn-featured btn btn-sm'
                    text='Resgatar agora'
                    onClick={this.handlerFinalizePayment}
                    loading={this.props.sendRedemptionMileage}
                    disabled={this.handlerDisableButton(
                      this.state.packageSelected.milesQuantity,
                      this.state.packageSelected.pointsQuantity,
                      this.state.acceptTerms
                    )}
                  />
                </div>
              </Loading>
            </div>
            <div>
              <ModalServices
                title={'Termos do Regulamento de Shell Box'}
                show={this.state.showModal}
                onClose={e => this.setState({ showModal: false })}
                acceptTerms={e => this.acceptTermsEvent(true)}
                terms={{
                  vendorId: shellSupplierId,
                  type: REGULATION_TYPE_VENDOR
                }}
                isLoading={this.props.sendRedemption}
              />
            </div>
            {this.props.sendTwoFactorAuthorization && this.props.sendTwoFactorAuthorization.enable && (
              <div className='modalConfirmationVoucher'>
                <SecondFactorAuthentication
                  show={
                    this.props.sendTwoFactorAuthorization.enable
                  }
                  onClose={() => this.props.closeSecondFactorModal()}
                  paymentSelected='POINTS_ONLY'
                  paymentPoints={null}
                  oidc={this.props.oidc}
                  confirmedOrderId={this.props.secondFactorAuthenticationOrderId}
                  closeModal={this.props.closeSecondFactorModal}
                  loadingResendToken={this.props.loadingResendToken}
                  sendTwoFactorAuthorization={this.props.sendTwoFactorAuthorization}
                  authorizeWithTokenMileage={this.props.authorizeWithTokenMileage}
                  authorizeWithTokenResend={this.props.authorizeWithTokenResend}
                  authorizeWithTokenLastTry={this.props.authorizeWithTokenLastTry}
                  isCreatingPurchase={this.props.isLoadingRedemption}
                  vendorId={shellSupplierId}
                  errorToken={this.props.sendTwoFactorAuthorization.errorToken}
                  secondFactorAuthConfirmated={
                    this.props.sendTwoFactorAuthorization.secondFactorAuthConfirmated
                  }
                  phone={this.props.sendTwoFactorAuthorization.phone}
                />
              </div>
            )}
          </div>
        )
      default:
        return ''
    }
  }

  render () {
    return (
      <div className='item-service col-12 col-md-8 col-lg-4 px-1 mb-lg-0 mb-3'>
        {this.renderByStep()}
        <div
          className='bg-white radius row px-1 mx-0 pt-2 pb-3 border-top-lg border-color-error'
          style={this.props.step === error ? {} : { display: 'none' }}
        >
          <div className='row px-1 mx-0'>
            <div className='col-10'>
              <p className='txt-body my-1'>
                <i className='icon icon_close_circle color-error' />
              </p>
            </div>
            <div className='col-2 pl-3'>
              <i
                className='icon icon_close txt-body-sm cursor'
                onClick={() => this.handleChangeStepFuelCredit(first)}
              />
            </div>
            <div className='col-12'>
              <p className='txt-body my-1 color-error'>
                Não foi possível concluir o sua transação.
              </p>
              <p className='txt-body-sm my-1'>{'Seu saldo é insuficiente.'}</p>
            </div>
            <div className='col-12 mt-1 mb-5 pb-5'>
              <Button
                id={'btnTryAgainFuelCredit'}
                name={'TryAgainFuelCredit'}
                className='btn-featured btn btn-sm btn-cart mb-5'
                text='TENTAR NOVAMENTE'
                onClick={() => this.btnTryAgain()}
              />
            </div>
          </div>
        </div>
        <div
          className='bg-white radius row px-1 mx-0 pt-2 pb-3 border-top-lg border-color-success'
          style={this.props.step === success ? {} : { display: 'none' }}
        >
          <div className='row px-1 mx-0'>
            <div className='col-10'>
              <p className='txt-body my-1'>
                <i className='icon icon_check_circle color-success' />
              </p>
            </div>
            <div className='col-2 pl-3'>
              <i
                className='icon icon_close txt-body-sm cursor'
                onClick={() => this.handleChangeStepFuelCredit(first)}
              />
            </div>
            <div className='col-12'>
              <p className='txt-body my-1 color-success'>
                Parabéns! Seu resgate foi concluído com sucesso.
              </p>
            </div>
            <div className='col-12 my-1'>
              <p className='txt-body-sm'>
                Transferência: <strong>{'Shell Box'}</strong>
              </p>
              <p className='txt-body-sm'>
                Valor em pontos: <strong>{'100 pontos'}</strong>
              </p>
              <p className='txt-body-sm'>
                Valor em créditos: <strong>{'R$ 100,00'}</strong>
              </p>
            </div>
            <div className='col-12 mt-1 mb-5'>
              <Button
                id={'btnTryAgainRecharge'}
                name={'TryAgainRecharge'}
                className='btn-featured btn btn-sm btn-cart mb-5'
                text='Ver detalhes'
                onClick={() => this.btnTryAgain()}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const packageType = PropTypes.shape({
  description: PropTypes.string.isRequired,
  partnerId: PropTypes.number.isRequired
})

FuelCredit.propTypes = {
  packages: PropTypes.arrayOf(packageType).isRequired,
  isLoading: PropTypes.bool.isRequired,
  isLoadingRedemption: PropTypes.bool,
  loadPackagesBySupplierId: PropTypes.func.isRequired,
  currencyConfiguration: PropTypes.object,
  participant: PropTypes.object,
  redemptionFuelCredit: PropTypes.func.isRequired,
  sendRedemption: PropTypes.bool.isRequired,
  sendRedemptionMileage: PropTypes.bool,
  participantBalance: PropTypes.number,
  step: PropTypes.string,
  changeStepFuelCredit: PropTypes.func.isRequired,
  redirectFuelCreditError: PropTypes.func,
  pointsValue: PropTypes.string,
  clientId: PropTypes.string,
  oidc: PropTypes.object,
  secondFactorAuthenticationOrderId: PropTypes.number,
  closeSecondFactorModal: PropTypes.func,
  authorizeWithTokenResend: PropTypes.func,
  secondFactorAuthConfirmated: PropTypes.bool,
  phone: PropTypes.string,
  sendTwoFactorAuthorization: PropTypes.object,
  order: PropTypes.object,
  navigateToServiceConfirmation: PropTypes.func,
  loadingResendToken: PropTypes.bool,
  authorizeWithTokenMileage: PropTypes.func,
  authorizeWithTokenLastTry: PropTypes.func
}

const mapStateToProps = ({
  fuelCredit,
  mileage,
  catalog: { currencyConfiguration },
  participant,
  balance: { pointsValue: participantBalance },
  oidc
}) => {
  const { user } = oidc
  const { profile } = user || {}
  return {
    ...fuelCredit,
    currencyConfiguration,
    participant,
    participantBalance,
    pointsValue: currencyConfiguration.pointsName,
    clientId: profile && profile['custom:client_id'],
    oidc,
    errorRedemption: mileage.errorRedemption,
    sendRedemptionMileage: mileage.sendRedemptionMileage,
    pointsToMiles: mileage.pointsToMiles,
    sendTwoFactorAuthorization: mileage.sendTwoFactorAuthorization,
    loadingResendToken: mileage.loadingResendToken,
    order: mileage.order
  }
}

const mapDispatchToProps = dispatch => ({
  loadPackagesBySupplierId: (shellSupplierId, participantClientId) =>
    dispatch(
      actions.loadPackagesBySupplierId(shellSupplierId, participantClientId)
    ),
  redemptionFuelCredit: (order, state) =>
    dispatch(actions.redemptionFuelCredit(order, state)),
  changeStepFuelCredit: stepValue =>
    dispatch(actions.changeStepFuelCredit(stepValue)),
  redirectFuelCreditError: (descriptionErrorFuelCredit, state) =>
    dispatch(actions.redirectFuelCreditError(descriptionErrorFuelCredit, state)),
  closeSecondFactorModal: () => dispatch({ type: 'CLOSE_SECOND_FACTOR' }),
  authorizeWithTokenResend: (
    OrderId,
    PaymentMoneyRequest,
    Token,
    TokenType,
    Resend
  ) =>
    dispatch(
      checkoutActions.authorizeWithTokenResend(
        OrderId,
        PaymentMoneyRequest,
        Token,
        TokenType,
        Resend
      )
    ),
  authorizeWithTokenMileage: (
    orderId,
    Token,
    orderIdMileage,
    vendorId,
    lastTry
  ) =>
    dispatch(
      actions.authorizeWithTokenMileage(
        orderId,
        Token,
        orderIdMileage,
        vendorId,
        lastTry
      )
    ),
  navigateToServiceConfirmation: liveOrderId => dispatch(actions.navigateToServiceConfirmation(liveOrderId))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FuelCredit)



// WEBPACK FOOTER //
// ./src/features/Services/FuelCredit/FuelCredit.js